import { Collections } from "../pages/Market/Collections.enum";

export class Shared {

    /**
     * Get enum keys of enum
     * @param obj 
     * @returns 
     */
    public enumKeys<O extends object, K extends keyof O = keyof O>(obj: O): K[] {
        return Object.keys(obj).filter(k => !Number.isNaN(k)) as K[]
    }

    /**
     * Get collection name
     * @param collection 
     * @returns 
     */
    public getCollectionName(collection: string): Collections {
        let collectionName: Collections;

        for (const tl of this.enumKeys(Collections)) {
            if (collection === tl) {
                collectionName = Collections[tl];
            }
        }

        return collectionName;
    }
}